var portfolioTransactionEdit = {
	title: "Transactie bewerken",
	subTitle: "Portfolio: {name}",
	buy: "Kopen",
	sell: "Verkopen",
	buyDate: "Koopdatum",
	sellDate: "Verkoopdatum",
	quantity: "Aantal/Nominaal",
	buyPrice: "Koopprijs",
	exchangeRate: "Wisselkoers",
	exchangeRateFormat: "{from}/{to}",
	confirmBtn: "Ok",
	cancelBtn: "Annuleren",
	buyValueInPortfolioCurrency: "Koopwaarde (portefeuille-valuta)",
	buyValueInNotationCurrency: "Koopwaarde (notatie-valuta)",
	sellValueInPortfolioCurrency: "Verkoopwaarde (portefeuille-valuta)",
	sellValueInNotationCurrency: "Verkoopwaarde (notatie-valuta)",
	transactionType: "Transactiesoort",
	sellPrice: "Verkoopprijs",
	validationErrors: {
		buyDate: {
			invalidInput: "Ongeldige datum. Geldig formaat yyyy-MM-dd'T'HH:mm"
		},
		buyPrice: {
			invalidInput: "Ongeldige prijs."
		},
		exchangeRate: {
			invalidInput: "Ongeldige wisselkoers"
		},
		quantity: {
			invalidInput: "Ongeldig aantal"
		}
	}
};
var nl = {
	portfolioTransactionEdit: portfolioTransactionEdit
};

export { nl as default, portfolioTransactionEdit };
